module.exports = ""


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/login_sucess/loginsuc.component.html
// module id = ../../../../../src/app/login_sucess/loginsuc.component.html
// module chunks = main